
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"86","height":"134","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.046 2.28c1.274 1.562 4.433 4.802 6.882 5.26 3.062.574 15.854 7.205 17.466 10.645 1.293 2.287 2.812 7.716-1.451 11.135-1.748 2.511-7.588 6.115-16.961.44-.05.871.205 2.867 1.624 3.874 1.773 1.26 6.43 4.62 7.957 4.798 1.528.178 18.252 7.36 19.268 12.99 1.378 2.794 3.067 9.19-1.2 12.435-2.034 2.664-8.582 6.359-18.5-.173-2.88-1.956-8.87-6.428-9.799-8.667-.584-.13-1.563.128-.813 2.197.937 2.587 10.575 13.434 13.447 15.1 2.872 1.667 18.576 11.486 19.782 16.024 1.142 2.074 2.926 7.104.929 10.638-2.497 4.416-6.326 7.78-11.121 7.469-4.132.107-13.43-1-17.57-6.289-.066.292-.005 1.523.759 4.114.954 3.239 3.637 22.753-6.499 26.28-4.149 2.211-14.073 4.369-20.575-4.688-2.558-3.56-7.412-12.254-6.356-18.548.068-.147-.01-.391-.876-.195-1.081.246-9.745 1.776-13.772-2.471-1.404-.979-4.32-3.805-4.759-7.275-.547-4.337 2.367-9.418 6.202-12.563 3.835-3.146 10.67-8.11 11.516-9.003.848-.892 11.282-9.65 13.544-14.713.766-1.253 2.2-4.148 1.81-5.704-.71.599-2.297 2.018-2.97 2.906-.842 1.11-8.89 9.587-14.967 10.18-2.67.577-8.552.831-10.734-2.768-1.64-1.698-4.467-6.107-2.657-10.158.67-2.12 3.425-7.182 9.084-10.462 3.084-1.788 3.548-2.12 2.961-1.855-1.022.523-1.967 1.009-2.754 1.414 1.041-.555 2.264-1.193 2.754-1.414 4.372-2.238 10.154-5.166 10.993-5.47 1.293-.47 4.9-4.044 5.679-7.546-1.643.986-5.102 2.961-5.798 2.98-.87.022-9.522 1.987-11.38-2.534-2.029-2.704-4.934-9.01-.328-12.612 1.838-1.86 6.933-6.185 12.615-8.596 2.009-.85 6.237-2.816 7.08-3.883 1.053-1.333.824-1.762 1.895-2.442 1.07-.68 4.515-2.076 7.593-.85z","fill":"#F3DEE5"}})])
          )
        }
      }
    